import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavCreateActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.34 5.56002L12.88 0.640024C12.34 0.320024 11.66 0.320024 11.12 0.640024L2.65998 5.56002C2.11998 5.87002 1.78998 6.45002 1.78998 7.07002V16.92C1.78998 17.54 2.11998 18.12 2.65998 18.43L11.12 23.35C11.66 23.67 12.34 23.66 12.88 23.35L21.34 18.43C21.88 18.12 22.21 17.54 22.21 16.92V7.08002C22.21 6.46002 21.88 5.88002 21.34 5.57002V5.56002ZM18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H5.99998C5.44998 13 4.99998 12.55 4.99998 12C4.99998 11.45 5.44998 11 5.99998 11H11V6.00002C11 5.45002 11.45 5.00002 12 5.00002C12.55 5.00002 13 5.45002 13 6.00002V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavCreateActiveIcon.displayName = 'NavCreateActiveIcon';
